import Api from '../../shared/Api';

class InvoicablesApi {
    static getInvoicablesFilter(): any {
        return new Api().get('/views/invoicables/filter');
    }
    static getInvoicables(
        regionId: number,
        brokerChainId: number,
        country: number,
        legalEntityId: number,
        site: number,
        invoiceInterval: number
        ): any {
        return new Api().get(`/views/invoicables`, {
            regionId: regionId,
            brokerChainId: brokerChainId,
            country: country,
            legalEntityId: legalEntityId,
            site: site,
            invoiceInterval: invoiceInterval
        });
    }
    
    static newInvoice(
        invoiceDate: any,
        message: string,
        otherFirmName: string,
        otherInvoiceAddress: string,
        brokerFirmId: number,
        invoiceChecksum: number
    ): any {
        return new Api().get(`/views/invoices/new`, {
            invoiceDateYear: invoiceDate.getYear() + 1900,
            invoiceDateMonth: invoiceDate.getMonth() + 1,
            invoiceDateDay: invoiceDate.getDate(),
            message: message === null ? null : encodeURIComponent(message),
            otherFirmName: otherFirmName === null ? null : encodeURIComponent(otherFirmName),
            otherInvoiceAddress:
                otherInvoiceAddress === null ? null : encodeURIComponent(otherInvoiceAddress),
            brokerFirmId: brokerFirmId,
            invoiceCheckSum: invoiceChecksum
        });
    }

    static createInvoice(
        invoiceDate: any,
        language: string,
        message: string,
        otherFirmName: string,
        otherInvoiceAddress: string,
        brokerFirmId: number,
        invoiceChecksum: number,
        exchangeRate: number
    ): any {
        return new Api().post(`/views/invoices`, {
            invoiceDate: invoiceDate,
            language: language,
            message: message,
            otherFirmName: otherFirmName,
            otherInvoiceAddress: otherInvoiceAddress,
            brokerFirmId: brokerFirmId,
            invoiceCheckSum: invoiceChecksum,
            InvoiceCurrencyToLegalEntityExchangeRate: exchangeRate
        });
    }

    static createInvoices(
        selectedItems: any[],
        invoiceDate: any,
        languageKey: string
    ): any {
        return new Api().post(`/views/invoices/bulk`, {
            selectedItems: selectedItems.map(selectedItem => ({
                invoiceDate: invoiceDate,
                brokerFirmId: selectedItem.brokerFirmId,
                invoiceChecksum: selectedItem.invoiceReceiverCheckSum,
                language: languageKey,
                message: null,
                otherFirmName: null,
                otherInvoiceAddress: null,
                InvoiceCurrencyToLegalEntityExchangeRate: null
            }))
        });
    }

    static markAsVoid(
        invoiceDate: any,
        language: string,
        message: string,
        otherFirmName: string,
        otherInvoiceAddress: string,
        brokerFirmId: number,
        invoiceChecksum: number
    ): any {
        return new Api().post(`/views/invoices/mark-as-void`, {
            invoiceDate: invoiceDate,
            language: language,
            message: message,
            otherFirmName: otherFirmName,
            otherInvoiceAddress: otherInvoiceAddress,
            brokerFirmId: brokerFirmId,
            invoiceCheckSum: invoiceChecksum
        });
    }
}

export default InvoicablesApi;
